export default "__VITE_ASSET__C9j9hIBi__"